"use client";
import { SnackbarProvider } from "notistack";
import React from "react";

const SnackPackProvider = ({ children }) => {
  return (
    <SnackbarProvider
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      autoHideDuration={3000}
      maxSnack={4}
    >
      {children}
    </SnackbarProvider>
  );
};

export default SnackPackProvider;
